import React, { useEffect, useState } from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import { listSupervisedBanks } from '../../api/supervisor';
import './SupervisorBanksPage.css';

const SupervisorBanksPage = () => {
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    listSupervisedBanks()
      .then((data) => { if (!cancelled) setBanks(data); })
      .catch(() => { if (!cancelled) setError('Impossible de charger les banks.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <SupervisorLayout>
      <h2 className="svb-title">Mes Banks</h2>

      {error && <p className="svb-error">{error}</p>}
      {loading ? (
        <p>Chargement...</p>
      ) : (
        <div className="svb-table-wrap">
          <table className="svb-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Username</th>
                <th>Nom</th>
                <th>Group</th>
                <th>Adresse</th>
                <th>Telephone</th>
                <th>Vente activee</th>
              </tr>
            </thead>
            <tbody>
              {banks.map((bank) => (
                <tr key={bank.id}>
                  <td>{bank.seq}</td>
                  <td>{bank.username || '—'}</td>
                  <td>{bank.name}</td>
                  <td>{bank.group_name || ''}</td>
                  <td>{bank.address}</td>
                  <td>{bank.phone || '—'}</td>
                  <td>{bank.sale_enabled ? 'Oui' : 'Non'}</td>
                </tr>
              ))}
              {banks.length === 0 && (
                <tr><td colSpan={7} className="svb-empty">Aucun bank supervise.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </SupervisorLayout>
  );
};

export default SupervisorBanksPage;
